import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';
import BreadCrumbs from './BreadCrumbs';

import config from './../config';

class SyslurListView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/syslur/';

		this.state = {}
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id != this.props.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		fetch(this.url+(this.props.match.params.id ? this.props.match.params.id+'/' : ''))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: (json.results || json.hreppar),
					single: Boolean(json.id),
					sysla: (json.id && json.nafn ? {
						id: json.id,
						nafn: json.nafn
					} : null)
				});
			}.bind(this));
	}

	render() {
		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					{
						this.state.data &&
						<div className="column-content">
							{
								this.state.sysla &&
								<BreadCrumbs path={[
									{
										path: '/syslur/',
										title: 'Sýslur'
									},
									{
										path: '/syslur/'+this.state.sysla.syslan,
										title: this.state.sysla.nafn
									}
								]} />
							}
							{
								this.state.single &&
								<h3>{this.state.sysla.nafn}</h3>
							}
							{
								!this.state.single &&
								<h3>Sýslur</h3>
							}
							<hr/>

							{
								this.state.single &&
								<h5>Hreppar</h5>
							}

							<table className="table table-responsive">
								<thead>
									<tr>
										<th>Titill</th>
									</tr>
								</thead>
								<tbody>
									{
										this.state.data.map((item, index) => <tr key={index}>
											<td><Link to={item.hreppur ? '/hreppur/'+item.hreppur : '/syslur/'+item.id}>{item.nafn}</Link></td>
										</tr>)
									}
								</tbody>
							</table>

						</div>
					}

				</div>

			</div>
		);
	}
}

export default withRouter(SyslurListView);



// WEBPACK FOOTER //
// ./src/components/SyslurListView.js